import {Component, Input} from '@angular/core';

export interface CheckmarkListEntry {
  name?: string;
  value: string;
}

@Component({
  selector: 'dcp-checkmark-list',
  templateUrl: './checkmark-list.component.html',
  styleUrls: ['./checkmark-list.component.scss']
})
export class CheckmarkListComponent {

  @Input() entries: CheckmarkListEntry[] = [];
  @Input() useBoxIcon: boolean = false;
}
